import { FunctionComponent, memo, useCallback, useRef, useState } from 'react';

import { TableLinkTo } from '..';
import Tooltip from '../common/tooltip';
import {
	TAppraisalInfoPopupButtonProps,
	TAppraisalInfoPopupProps,
} from './appraisal-info-popup.type';
import AppraisalInfoPopup from './appraisal-info-popup.view';

const AppraisalInfoPopupButton = ({
	className,
	label = 'label',
	...props
}: TAppraisalInfoPopupButtonProps) => {
	const [open, setOpen] = useState(false);

	const appraisalInfoPopup =
		useRef<FunctionComponent<TAppraisalInfoPopupProps>>();

	const onOpenModal = useCallback(() => {
		if (!appraisalInfoPopup.current) {
			appraisalInfoPopup.current = AppraisalInfoPopup;
		}

		setOpen(true);
	}, [appraisalInfoPopup.current]);

	const onCancel = useCallback(() => {
		setOpen(false);
	}, []);

	return (
		<div className="render-cell" onClick={(e) => e?.stopPropagation()}>
			<Tooltip title={label} destroyTooltipOnHide>
				<TableLinkTo label={label} onClick={onOpenModal} />
			</Tooltip>
			{appraisalInfoPopup.current && (
				<appraisalInfoPopup.current {...{ ...props, open, onCancel }} />
			)}
		</div>
	);
};

export default memo(AppraisalInfoPopupButton);
